import React from 'react';
import { Grid, Box } from '@mui/material';
import { EventAndRidesCardV2Skeleton } from 'views/rebranded-module/common/components';

const RidesListSectionSkeleton = () => (
  <Box my={8}>
    <Grid container columnSpacing={6} rowSpacing={{ lg: 8, md: 5, xs: 5 }}>
      {[...Array(6)].map((_, item) => (
        <Grid item xs={12} md={12} lg={6} key={item}>
          <EventAndRidesCardV2Skeleton />
        </Grid>
      ))}
    </Grid>
  </Box>
);
export { RidesListSectionSkeleton };
